var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100 overflow-hidden",style:(_vm.computedStyle),attrs:{"id":_vm.id}},[_c('img',{staticClass:"img-fluid w-100",attrs:{"src":_vm.imgSource,"data-cloudinary-parameters":_vm.cloudinaryParameters,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }